exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".relative .material-icons {\n  position: absolute;\n  top: 0;\n  right: 0; }\n\n.dropdown button {\n  background: none;\n  width: 100%;\n  text-align: left;\n  outline: 0; }\n  .dropdown button.input-underline:focus {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12); }\n\n.dropdown .dropdown-menu {\n  width: 10rem;\n  box-shadow: 0 8px 8px 0 rgba(0, 0, 0, 0.24), 0 0 8px 0 rgba(0, 0, 0, 0.12);\n  background-color: #fafafa;\n  top: 1.3rem;\n  left: -1px;\n  padding: 10px 22px; }\n  .dropdown .dropdown-menu .dropdown-item {\n    color: rgba(0, 0, 0, 0.87);\n    padding: 0;\n    margin-bottom: 20px; }\n    .dropdown .dropdown-menu .dropdown-item:last-child {\n      margin-bottom: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/custom-dropdown/custom-dropdown.component.scss
// module id = ../../../../../src/app/shared/components/custom-dropdown/custom-dropdown.component.scss
// module chunks = main